<template>
  <div class="add-tags-to-answers">
    <span @click="$emit('closeAddTagsToQuestions')" class="material-icons">
      close
    </span>
    <div class="single-answer" v-for="el in question.answers" :key="el.pqa_id">
      <span> ID: {{ el.pqa_id }} </span>
      <br />
      <span> TEXT: {{ el.text }}  </span>
      <DropDown
        :id="el.pqa_id"
        :options="tags"
        displayKey="tag_name"
        :isOpened="el.open"
        @get-value="handleTags"
        class="dropdown"
        @set-opened="openDropDown(el.pqa_id)"
      />
    </div>
    <button @click="save">Save</button>
  </div>
</template>

<script>
import api from '@/api'
import DropDown from "@/components/list-of-attendees/DropDown.vue";
export default {
  components: {
    DropDown,
  },
  props: {
    question: {
      type: Object,
    },
    tags: {
      type: Array,
    },
  },
  data() {
    return {
      editedQuestions: [],
      selectedId: null,
      selectedTags: [],
    };
  },
  mounted() {
    if (this.question.answers) {
      this.question.answers.forEach((element) => {
        this.$set(element, "open", false);
        this.$set(element, "tags", []);
        if(!element.pqa_id) {
          this.$set(element, "pqa_id", Math.floor(Math.random()*10000000));
        }
      });
    }
  },
  watch: {
    selectedId(val) {
      if (val) this.selectedTags = [];
    },
  },
  methods: {
    openDropDown(id) {
      this.selectedId = id;
      this.question.answers.forEach((element) => {
        if (element.pqa_id == id) {
          if (element.open == true) {
            element.open = false;
          } else {
            element.open = true;
          }
        }
      });
    },
    handleTags(tags) {
      this.selectedTags = [];
      tags.forEach((tag) => {
        this.selectedTags.push(tag.tag_id);
      });
      this.question.answers.forEach((element) => {
        if (element.pqa_id == this.selectedId) element.tags = this.selectedTags;
      });
    },
    save() {
      this.$emit("addedTagsToAnswers", this.question);
    },
  },
};
</script>

<style scoped lang='scss'>
.add-tags-to-answers {
  padding: 30px;
  position: absolute;
  width: 1000px;
  min-height: 100px;
  z-index: 11;
  left: 50%;
  top: 10%;
  background: #fff;
  transform: translateX(-50%);
  button {
    margin: 20px auto;
    display: block;
  }
  .single-answer {
    border-bottom: 1px solid black;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    span {
      display: inline-block;
      margin: 0 0 10px 0;
    }
  }
  .material-icons {
    position: absolute;
    font-size: 20px;
    top: 10px;
    left: calc(100% - 30px);
    cursor: pointer;
  }
}
</style>